import request from '@/utils/request';

export function getLoginWeChatUrl(params) {
  return request({
    url: '/User/getLoginWeChatUrl',
    params,
  });
}

export function login(username, password) {
  return request({
    url: '/User/login',
    method: 'POST',
    data: {
      username,
      password,
    },
  });
}

export function getUserBindMobileInfo() {
  return request({
    url: '/User/bindMobile',
  });
}

export function bindMobile(mobile, smsCode) {
  return request({
    url: '/User/bindMobile',
    method: 'POST',
    data: {
      mobile,
      sms_code: smsCode,
    },
  });
}

export function register(mobile, smsCode, password, passwordCheck) {
  return request({
    url: '/User/register',
    method: 'POST',
    data: {
      mobile,
      sms_code: smsCode,
      password,
      passwordCheck,
    },
  });
}

export function sendSmsCode(phone, type) {
  return request({
    url: '/User/sendSmsCode',
    method: 'POST',
    data: {
      phone,
      type,
    },
  });
}

export function logout() {
  return request({
    url: '/User/logout',
    method: 'POST',
  });
}

export function getUserLoginWithToken() {
  return request({
    url: '/User/loginWithToken',
    method: 'POST',
  });
}

export function getUserLoginWithQueryToken(data) {
  return request({
    url: '/User/loginWithQueryToken',
    method: 'POST',
    data,
    silentRequest: true,
  });
}
